import { Link } from "react-router-dom";

export const LogoMark = ({ className = "" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <rect width="40" height="40" rx="10" fill="#0F1E36" />
    <path d="M9 21.5 20 12l11 9.5" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 20v9h14v-9" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="20" cy="24.5" r="2.6" fill="#4ADE80" />
  </svg>
);

export const Logo = ({ light = false, testId = "nav-logo" }) => (
  <Link to="/" data-testid={testId} className="group flex items-center gap-3" aria-label="Easy Handyman Services – home">
    <LogoMark className={`h-10 w-10 shrink-0 transition-transform duration-500 group-hover:-rotate-6 ${light ? "ring-1 ring-white/20 rounded-[10px]" : ""}`} />
    <span className="flex flex-col leading-none">
      <span className={`font-display text-[15px] sm:text-base font-extrabold tracking-[0.14em] ${light ? "text-white" : "text-[var(--navy)]"}`}>
        EASY HANDYMAN
      </span>
      <span className={`mt-1 font-display text-[10px] font-semibold tracking-[0.42em] ${light ? "text-[var(--green-bright)]" : "text-[var(--green)]"}`}>
        SERVICES
      </span>
    </span>
  </Link>
);
